import React, { useState } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Modal } from '../ui/Modal';
import { motion } from 'framer-motion';
import { useStore, Leader } from '../store/usestore';

export const Leadership = () => {
  const { leaders } = useStore();
  const [selectedLeader, setSelectedLeader] = useState<Leader | null>(null);

  return (
    <SectionWrapper id="leadership" className="bg-background-light">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Our Leadership</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Guided by experienced and dedicated leaders committed to the vision of a prosperous Nigeria.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {leaders.map((leader) => (
          <LeaderCard key={leader.id} leader={leader} onClick={() => setSelectedLeader(leader)} />
        ))}
      </div>

      <Modal
        isOpen={!!selectedLeader}
        onClose={() => setSelectedLeader(null)}
        title={selectedLeader?.name}
      >
        {selectedLeader && (
          <div className="space-y-6">
            <div className="flex flex-col md:flex-row gap-6 items-start">
              <div className="w-full md:w-1/3 rounded-xl overflow-hidden shadow-md">
                <img src={selectedLeader.image} alt={selectedLeader.name} className="w-full h-full object-cover" />
              </div>
              <div className="w-full md:w-2/3 space-y-4">
                <div>
                  <p className="text-gray-700 leading-relaxed">{selectedLeader.bio}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </SectionWrapper>
  );
};

const LeaderCard = ({ leader, onClick }: { leader: Leader; onClick: () => void }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow cursor-pointer border border-transparent hover:border-accent flex flex-col items-center text-center"
      onClick={onClick}
    >
      <div className="w-full aspect-[3/4] rounded-lg overflow-hidden mb-4 bg-gray-100">
        <motion.img 
          src={leader.image} 
          alt={leader.name} 
          className="w-full h-full object-cover"
          initial={{ opacity: 0 }}
          animate={{ opacity: imageLoaded ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          onLoad={() => setImageLoaded(true)}
          loading="lazy"
          decoding="async"
        />
      </div>
      <h3 className="text-xl font-bold text-gray-900">{leader.name}</h3>
      <p className="text-primary font-medium">{leader.title}</p>
      {leader.govTitle && <p className="text-sm text-gray-500 mt-1">{leader.govTitle}</p>}
    </motion.div>
  );
};
